module.exports = {
  dimensions: {
    width: 38,
    height: 38
  },
  content: {
    top: 1,
    left: 1,
    right: 1,
    bottom: 1
  },
  nine: {
    top: 7,
    left: 7,
    right: 7,
    bottom: 7
  },
  optical: {
    top: 1,
    left: 1,
    right: 1,
    bottom: 1
  }
};